import FourOFourPage from "./404.page";

/**
 * We only have .com/[brand-name] urls so our .com address is atm not a valid url
 */
export default FourOFourPage;
